import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  cartId: string;
};

export type ChangeItemShipmentData = {
  cartId: string;
  storeId: string | null;
  itemId: string;
  type: 'deliveryCompany' | 'pickupInStore';
};

export type Response = {};

export type Body = {
  items: {
    storeId: string | null;
    itemId: string;
    type: 'deliveryCompany' | 'pickupInStore';
  }[];
};

const changeItemShipment: ServiceMethod<Response, ChangeItemShipmentData> =
  (httpClient) => async (data, options) => {
    const { cartId, itemId, type, storeId } = data;

    const { body: response } = await httpClient.put<Response, Body, Params>(
      '/api/v3/carts/{cartId}/change-item-shipment',
      {
        ...options,
        body: {
          items: [
            {
              storeId,
              itemId,
              type,
            },
          ],
        },
        params: { cartId },
      }
    );

    return response;
  };

export default changeItemShipment;
